import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { actions } from '../../../store';

export interface UseVoicemailFileDownloadParams {
  i_account?: number;
}

export interface VoicemailDownloadFn {
  (
    message_uid: number,
    callback: (url: string) => void,
    restrictedCallback?: () => void,
  ): void;
}

// Provides a stable callback to download voicemail files via Redux action.
export const useVoicemailFileDownload = (
  params: UseVoicemailFileDownloadParams,
): VoicemailDownloadFn => {
  const dispatch = useDispatch();
  const { i_account } = params;

  const download = useCallback<VoicemailDownloadFn>(
    (message_uid, callback, restrictedCallback) => {
      dispatch(
        actions.getVoicemailFile.request({
          format: 'wav',
          i_account,
          message_uid,
          callback,
          restrictedCallback,
        }),
      );
    },
    [dispatch, i_account],
  );

  return download;
};

